import { Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { WebRouletteService } from 'app/public/services/web-roulette.service';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { FieldTypes } from 'app/shared/model/enums';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, switchMapTo, tap } from 'rxjs/operators';
import { CommonService } from 'app/shared/services/common.service';
import { Filter } from 'app/shared/components/table/filter';
import { CouponStatus } from 'app/core/model/enums/status-enum';
import { ConfirmationService } from 'primeng/api';
import { CouponService } from 'app/core/services/coupon.service';
import { AdvMessageService } from 'app/shared/services/message.service';
import { BaseLids } from '../base-lids';
import { BusinessManagmentService } from 'app/core/services/business-managment.service';

@Component({
  selector: 'app-lids',
  templateUrl: './lids.component.html',
  styleUrls: ['./lids.component.scss']
})
export class LidsComponent extends BaseLids implements OnInit, OnDestroy {
  constructor(webRouletteService: WebRouletteService, managmentService:BusinessManagmentService, localizationService: LocalizationService, commonService: CommonService) {
    super(webRouletteService,managmentService, localizationService, commonService)
  }
  ngOnDestroy(): void {
    if(!this.businessId)
      this.destroy();
  }
  ngOnInit(): void {
    this.init();
  }
  onLoadData(event) {
    this.request.Paging = event.Paging;
    this.loadLids();
  }

}
